module.exports = "/virtual-football-league/img/video/clubs/england/m-city.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/england/m-city.png
// module id = 336
// module chunks = 4